import { api } from '@lib/api';

/**
 * MCP login handoff (Seçenek B) — giriş ekranı tarafı.
 *
 * Kullanıcı Claude'dan "Zoprey'e bağlan" dediğinde MCP, /authorize → giriş
 * ekranına `?mcp_redirect=<MCP callback>&ar=<auth request>` ile yönlendirir.
 * Giriş başarılı olunca backend'den tek-kullanımlık handoff kodu alıp kullanıcıyı
 * `${mcp_redirect}?ar=<...>&handoff=<code>` adresine geri göndeririz.
 */

const STASH_KEY = 'mcp_handoff_params';

interface McpParams {
  mcpRedirect: string;
  ar: string;
}

function readFromUrl(): McpParams | null {
  const sp = new URLSearchParams(window.location.search);
  const mcpRedirect = sp.get('mcp_redirect');
  const ar = sp.get('ar');
  if (mcpRedirect && ar) return { mcpRedirect, ar };
  return null;
}

/** URL'de MCP parametreleri varsa Google redirect'i öncesinde sakla. */
export function stashMcpParamsIfPresent(): void {
  const p = readFromUrl();
  if (p) sessionStorage.setItem(STASH_KEY, JSON.stringify(p));
}

function takeParams(): McpParams | null {
  const fromUrl = readFromUrl();
  if (fromUrl) return fromUrl;
  const stashed = sessionStorage.getItem(STASH_KEY);
  if (stashed) {
    sessionStorage.removeItem(STASH_KEY);
    try {
      return JSON.parse(stashed) as McpParams;
    } catch {
      return null;
    }
  }
  return null;
}

/**
 * Giriş başarılı olduktan sonra çağrılır. MCP bağlama akışı aktifse handoff
 * kodunu alır ve tarayıcıyı MCP callback'ine yönlendirir; true döner.
 * MCP akışı yoksa false döner (normal /dashboard yönlendirmesi yapılır).
 */
export async function completeMcpHandoff(): Promise<boolean> {
  const params = takeParams();
  if (!params) return false;

  const { code } = await api
    .post('auth/mcp-handoff')
    .json<{ code: string; expiresIn: number }>();

  const url = new URL(params.mcpRedirect);
  url.searchParams.set('ar', params.ar);
  url.searchParams.set('handoff', code);
  window.location.assign(url.toString());
  return true;
}
